<template>
<!-- selectedTvx: {{ selectedTvx }} -->
<!-- ROOF -->
<template v-if="props.itemType === 'roof'">
  <svg width="346" height="90" viewBox="0 0 346 90" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
    <g id="ROOFS"
    >
      <g id="ROOF-LOST" v-if="props.roofType === 'lost'"
      :class="{selectedTvx: props.selectedTvx === 'roof', canBeFocus: isTvxActive('roof')}"
      @click="clickItem('roof')"
      >
          <path id="ROOF-LOST_2"
            d="M0 55.1244C0 50.6213 3.00987 46.6736 7.35232 45.4813L170.352 0.726964C172.085 0.251127 173.915 0.251126 175.648 0.726964L338.648 45.4813C342.99 46.6736 346 50.6213 346 55.1244V89.2419H0V55.1244Z"
            fill="currentColor"
          />
      </g>
      <g id="ROOF-FLAT" v-if="props.roofType === 'flat'"
      :class="{selectedTvx: props.selectedTvx === 'roof', canBeFocus: isTvxActive('roof')}"
      @click="clickItem('roof')"
      >
            <path id="ROOF-FLAT_4"
              d="M0 58.2583C0 52.7354 4.47715 48.2583 10 48.2583H336C341.523 48.2583 346 52.7355 346 58.2583V90.0002H0V58.2583Z"
              fill="currentColor" />
      </g>
      <g id="ROOF-CONVERTED" v-if="props.roofType === 'converted'">
            <path id="ROOF-CONVERTED_3" fill-rule="evenodd" clip-rule="evenodd"
              d="M7.35232 46.1112C3.00987 47.3035 0 51.2512 0 55.7543V89.8718H15V64.8107C15 60.1839 18.174 56.1613 22.6738 55.085L170.674 19.6863C172.203 19.3205 173.797 19.3205 175.326 19.6863L323.326 55.085C327.826 56.1613 331 60.1839 331 64.8107V89.8718H346V55.7543C346 51.2512 342.99 47.3035 338.648 46.1112L175.648 1.35688C173.915 0.88104 172.085 0.881041 170.352 1.35688L7.35232 46.1112Z"
              fill="currentColor"
              
              :class="{selectedTvx: props.selectedTvx === 'roof', canBeFocus: isTvxActive('roof')}"
              @click="clickItem('roof')"
              />
            <path id="Rectangle 12" d="M210.316 11.0002L289.5 32.5L286.708 46.3329L206.637 27.5002L210.316 11.0002Z"
              fill="currentColor"
              class="bati-windows"
              :class="{selectedTvx: props.selectedTvx === 'windows', canBeFocus: isTvxActive('windows')}"
              @click="clickItem('windows')"
              />
            <!-- <g id="Vector">
              <path id="Vector_2"
                d="M174.938 41.2217C174.938 37.7529 177.719 34.9717 181.188 34.9717H192.125C195.563 34.9717 198.375 37.7842 198.375 41.2217V47.9717C194.75 49.2529 192.125 52.6904 192.125 56.7529V63.0967H174.938V41.2217ZM154.625 56.7217V63.0967H171.812V41.2217C171.812 37.7529 169.031 34.9717 165.562 34.9717H154.625C151.187 34.9717 148.375 37.7842 148.375 41.2217V47.9404C152 49.2217 154.625 52.6904 154.625 56.7217ZM200.437 50.6904C197.375 51.1904 195.25 54.0967 195.25 57.2217V66.2217H151.5V56.8467C151.5 55.1891 150.842 53.5994 149.669 52.4273C148.497 51.2552 146.908 50.5967 145.25 50.5967C143.592 50.5967 142.003 51.2552 140.831 52.4273C139.658 53.5994 139 55.1891 139 56.8467V72.4717C139 75.9092 141.812 78.7217 145.25 78.7217V84.9717H151.5V78.7217H195.25V84.9717H201.5V78.7217C204.938 78.7217 207.75 75.9092 207.75 72.4717V56.8467C207.75 53.0654 204.344 50.0342 200.437 50.6904Z"
                fill="blue" />
            </g> -->
        </g>
      </g>
    </svg>
  </template>

  <!-- BODY MI/LC + WINDOWS -->
  <!-- LC -->
  <template v-if="props.itemType === 'batiLC'">
    <svg width="346" height="502" viewBox="0 0 346 502" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
      <g id="BATI-LC">
        <g id="WALLS"
        class="bati-walls"
        :class="{selectedTvx: props.selectedTvx === 'walls', canBeFocus: isTvxActive('walls')}"
        @click="clickItem('walls')"
        >
          <path id="Rectangle 5" d="M0 0H346V491C346 496.523 341.523 501 336 501H10C4.47716 501 0 496.523 0 491V0Z"
            fill="currentColor" />
        </g>
        <g id="WINDOWS" class="bati-windows" fill="currentColor" stroke="#ffffff" stroke-width="3"
        :class="{selectedTvx: props.selectedTvx === 'windows', canBeFocus: isTvxActive('windows')}"
        @click="clickItem('windows')"
        >
          <rect id="Rectangle 4" x="71" y="60" width="68" height="70.7678" rx="10" />
          <rect id="Rectangle 6" x="71" y="164.07" width="68" height="70.7678" rx="10" />
          <rect id="Rectangle 8" x="71" y="268.141" width="68" height="70.7678" rx="10" />
          <path id="Rectangle 10"
            d="M152 409.269C152 403.746 156.477 399.269 162 399.269H210C215.523 399.269 220 403.746 220 409.269V501.258H152V409.269Z" />
          <rect id="Rectangle 5_2" x="207" y="60" width="68" height="70.7678" rx="10" />
          <rect id="Rectangle 7" x="207" y="164.07" width="68" height="70.7678" rx="10" />
          <rect id="Rectangle 9" x="207" y="268.141" width="68" height="70.7678" rx="10" />
        </g>
      </g>
    </svg>
  </template>
  <!-- MI -->
  <template v-if="props.itemType === 'batiMI'">
    <svg width="346" height="305" viewBox="0 0 346 305" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
      <g id="BATI-MI">
        <g id="WALLS"
        class="bati-walls"
        :class="{selectedTvx: props.selectedTvx === 'walls', canBeFocus: isTvxActive('walls')}"
        @click="clickItem('walls')"
        >
          <path id="Rectangle 5" d="M0 0H346V294C346 299.523 341.523 304 336 304H10C4.47716 304 0 299.523 0 294V0Z"
            fill="currentColor" />
        </g>
        <g id="WINDOWS"
        class="bati-windows"
        fill="currentColor"
        stroke="#ffffff"
        stroke-width="3"
        :class="{selectedTvx: props.selectedTvx === 'windows',   canBeFocus: isTvxActive('windows')}"
        @click="clickItem('windows')"
        >
          <rect id="Rectangle 8" x="71" y="71" width="68" height="70.7678" rx="10" />
          <path id="Rectangle 10"
            d="M152 212.129C152 206.606 156.477 202.129 162 202.129H210C215.523 202.129 220 206.606 220 212.129V304.118H152V212.129Z" />
          <rect id="Rectangle 9" x="207" y="71" width="68" height="70.7678" rx="10" />
        </g>
      </g>
    </svg>
  </template>


  <!-- ENV -->
  <template v-if="props.itemType === 'env'">
    <svg width="633" height="267" viewBox="0 0 633 267" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
      <g id="ENV"
      :class="{selectedTvx: props.selectedTvx === 'env',  canBeFocus: isTvxActive('env')}"
      @click="clickItem('env')"
      >
        <path id="TREE"
          d="M252 126C252 108.851 242.449 93.0384 226.409 80.3628C226.384 80.3502 226.359 80.3502 226.346 80.325C221.785 35.3178 178.63 0 126 0C73.3698 0 30.2148 35.3178 25.6536 80.325C25.641 80.3502 25.6158 80.3502 25.5906 80.3628C9.5508 93.0384 0 108.851 0 126C0 165.211 49.7322 197.429 113.4 201.222V214.2C113.4 226.8 90.4554 238.279 90.4554 238.279C89.8444 238.597 89.3691 239.126 89.1167 239.767C88.8644 240.408 88.8521 241.119 89.082 241.769C89.082 241.769 92.925 252 100.8 252C108.675 252 114.962 245.7 130.712 245.7C146.462 245.7 161.444 251.143 161.444 251.143C162.155 251.361 162.911 251.391 163.638 251.229C164.364 251.068 165.036 250.722 165.589 250.223L174.623 241.189C175.606 240.206 175.354 239.009 174.044 238.518C174.044 238.518 151.213 229.95 151.213 214.2V200.075C208.719 193.082 252 162.578 252 126ZM25.2 126C25.2 113.161 34.8768 101.493 50.6772 92.5974C50.5512 91.1358 50.4 89.6742 50.4 88.2C50.4 53.3988 84.2562 25.2 126 25.2C167.744 25.2 201.6 53.3988 201.6 88.2C201.6 89.6742 201.449 91.1358 201.335 92.5974C217.123 101.493 226.8 113.161 226.8 126C226.8 149.486 194.657 169.142 151.213 174.749V166.333C151.297 164.745 151.945 163.239 153.04 162.086L176.135 140.339C177.231 139.185 177.883 137.681 177.975 136.093V125.37C177.975 123.984 176.992 123.417 175.808 124.123L153.392 137.315C152.183 138.02 151.213 137.466 151.213 136.067V90.72C151.213 89.334 150.142 88.5528 148.819 88.9938L115.794 100.006C115.119 100.269 114.535 100.722 114.112 101.31C113.689 101.898 113.446 102.596 113.413 103.32V136.08C113.413 137.466 112.417 138.071 111.182 137.428L85.7052 124.022C85.0525 123.714 84.3233 123.608 83.6099 123.715C82.8965 123.823 82.2312 124.14 81.6984 124.627L77.3892 128.936C77.1575 129.162 76.9754 129.434 76.8547 129.734C76.7339 130.035 76.677 130.357 76.6877 130.681C76.6983 131.004 76.7763 131.322 76.9166 131.614C77.0569 131.906 77.2565 132.165 77.5026 132.376L111.523 162.124C112.568 163.044 113.413 164.921 113.413 166.307V175.946C63.7056 172.859 25.2 151.704 25.2 126Z"
          fill="currentColor" />
        <rect id="GROUND" y="242" width="633" height="25" rx="10" fill="currentColor" />
      </g>
    </svg>
  </template>


</template>

<script setup>
import {computed} from "vue";
const props = defineProps({
    itemType: {
      type: String,
      required: false,
    },
    roofType: {
      type: String,
      required: false,
    },
    selectedTvx: {
      type: String,
      required: false
    },
    activeItems: {
      type: Array,
      required: false,
      default: () => []
    }
});
const emit = defineEmits(['setSelectedTvx']);

const clickItem = (tvx) => {
  if (isTvxActive(tvx))
    emit('setSelectedTvx', tvx);
}

const activeItems = computed(() => props.activeItems);

const isTvxActive = (item) => {
  return activeItems.value.includes(item)
}


</script>